import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { formatValue } from '@ts-core/utils/dataTableUtils';
import Table, { TimeTableCell } from '@ts-core/components/Table';

import MediaItemThumbTableCell from 'modules/media/components/MediaItemThumbTableCell';

const CourseMediaStatsTable = (props) => {
  const intl = useIntl();
  const { onFetchStats, onFilterStats, onClickMediaItem, mediaStats, loading, error, onGetXlsxData } = props;
  const { totalViews, mediaItems = [] } = mediaStats;

  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: '_id',
        valueTransformer: (_value, _, mediaItem) => <MediaItemThumbTableCell mediaItem={mediaItem} />,
      },
      {
        Header: intl.formatMessage({ id: 'field.name.label' }),
        accessor: 'name',
      },
      {
        Header: intl.formatMessage({ id: 'subject' }),
        accessor: 'subject.name',
        id: 'subject.name',
        sortable: true,
        filterable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.duration' }),
        accessor: 'duration',
        valueTransformer: (value) => <TimeTableCell time={value} />,
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.totalViews' }),
        accessor: 'totalViews',
        Footer: totalViews ? `${totalViews}` : '-',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.studentsCount' }),
        accessor: 'studentsCount',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.viewsPerStudent' }),
        accessor: 'avgViewsPerStudent',
        valueTransformer: (value) => formatValue(value, undefined, false, 2),
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.avgProgress' }),
        accessor: 'avgProgressPercentage',
        valueTransformer: (value) => formatValue(value, 1),
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'mediaStatsTable.maxProgress' }),
        accessor: 'maxProgressPercentage',
        valueTransformer: (value) => formatValue(value, 1),
        sortable: true,
      },
    ],
    [intl, totalViews]
  );

  return (
    <Table
      data={mediaItems}
      columns={columns}
      loading={loading}
      errorMessage={error}
      onRefreshData={onFetchStats}
      onSearch={onFilterStats}
      onSelectRow={onClickMediaItem}
      allowDownloadAsXLSX
      getDataToExport={onGetXlsxData}
      xlsxFileName={intl.formatMessage({ id: 'courseMediaStatsTable.title' })}
    />
  );
};

CourseMediaStatsTable.propTypes = {
  onFetchStats: PropTypes.func,
  onFilterStats: PropTypes.func,
  onClickMediaItem: PropTypes.func,
  onGetXlsxData: PropTypes.func,

  mediaStats: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

CourseMediaStatsTable.defaultProps = {
  mediaStats: {},
  loading: false,
  error: undefined,
  onFetchStats: undefined,
  onFilterStats: undefined,
  onClickMediaItem: undefined,
  onGetXlsxData: undefined,
};

export default CourseMediaStatsTable;
